


















import {
  LoadingService,
  ExtendMixins,
} from '@/services';
import { getContentArea } from '@/contentful';
import { PageIntro, PageSidebar } from '@/components/page-components';
import { ReleaseAuthorizationListing } from '@/components/account-settings-components/personal-settings-components';
import { EventBus } from '@/event-bus';
import { OpenAddReleaseAuthorizationScreen } from '@/mixins/get-content-mixins';
import { CTA } from '@/@types/member';

interface Data {
  sidebarHeading: string;
  sidebarContent: string;
  ctaConfig: CTA;
}

export default ExtendMixins(
  OpenAddReleaseAuthorizationScreen,
).extend({
  name: 'ReleaseAuthorizations',
  beforeRouteEnter(to, from, next) {
    LoadingService.watchPromises(getContentArea('ari-sidebar-content'))
      .then((data) => {
        const sidebar = data[0];
        if (sidebar && sidebar.fields) {
          to.meta.sidebarHeading = sidebar.fields.headline;
          to.meta.sidebarContent = sidebar.fields.content;
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      ctaConfig: {
        text: this.$options.filters.t(['ari_action_add-ari', 'global_add-ari']),
        action: this.openAddReleaseAuthorizationScreen,
      },
    };
  },
  components: {
    PageIntro,
    PageSidebar,
    ReleaseAuthorizationListing,
  },
});
